import { createTheme, Theme } from "@mui/material";

const defaultTheme = createTheme();
const { breakpoints } = defaultTheme;

export const customTheme = {
  ...defaultTheme,
  palette: {
    primary: {
      main: "#1C1C1C",
      contrastText: "#ffffff",
    } as any,
    secondary: {
      main: "#D22268",
      contrastText: "#ffffff",
    } as any,
    tertiary: {
      main: "#0DAB76",
      contrastText: "#ffffff",
    } as any,
    success: {
      light: "#46C79D",
      main: "#0DAB76",
      dark: "#087856",
      contrastText: "#ffffff",
    },
    warning: {
      light: "#FBBF24",
      main: "#F59E0B",
      dark: "#B45309",
      contrastText: "#1C1C1C",
    },
    info: {
      light: "#eff2ff",
      main: "#4f46e5;",
      dark: "#1D4ED8",
      contrastText: "#ffffff",
    },
    error: {
      light: "#F87171",
      main: "#DC2626",
      dark: "#B91C1C",
      contrastText: "#ffffff",
    },
    black: {
      containedColor: "#fff",
      contrastText: "#fff",
      main: "#000",
    } as any,
    purple: {
      main: "#4F46E5",
    },
    white: {
      main: "#fff",
      contrastText: "#d22268",
    } as any,
  } as any,
  typography: {
    fontFamily: "'Jost', 'Inter', Helvetica, Arial, sans-serif",
    h1: {
      fontFamily: "Jost",
      fontWeight: 800,
      fontSize: "36.5px",
      lineHeight: "53px",
      [breakpoints.up("lg")]: {
        fontSize: "61px",
        lineHeight: "78px",
      },
    },
    h2: {
      fontFamily: "Jost",
      fontWeight: 600,
      fontSize: "32.4px",
      lineHeight: "47px",
      [breakpoints.up("lg")]: {
        fontSize: "48.8px",
        lineHeight: "64px",
      },
    },
    h3: {
      fontFamily: "Jost",
      fontWeight: 600,
      fontSize: "25.6px",
      lineHeight: "38px",
      [breakpoints.up("lg")]: {
        fontSize: "39.1px",
        lineHeight: "53px",
      },
    },
    h4: {
      fontFamily: "Jost",
      fontWeight: 600,
      fontSize: "22.8px",
      lineHeight: "33px",
      [breakpoints.up("lg")]: {
        fontSize: "31.25px",
        lineHeight: "44px",
      },
    },
    h5: {
      fontFamily: "Jost",
      fontWeight: 600,
      fontSize: "20.25px",
      lineHeight: "30px",
      [breakpoints.up("lg")]: {
        fontSize: "25px",
        lineHeight: "37px",
      },
    },
    h6: {
      fontFamily: "Jost",
      fontWeight: 600,
      fontSize: "18px",
      lineHeight: "28.8px",
      [breakpoints.up("lg")]: {
        fontSize: "20px",
        lineHeight: "28px",
      },
    },
    body1: {
      fontFamily: "Jost",
      fontSize: "16px",
      lineHeight: "25px",
      color: "#374151",
      // [breakpoints.up("lg")]: {
      //   fontSize: "16px",
      //   lineHeight: "25px",
      // },
    },
    body2: {
      fontFamily: "Jost",
      fontSize: "16px",
      lineHeight: "28px",
      [breakpoints.up("lg")]: {
        fontSize: "18px",
        lineHeight: "28px",
      },
    },
    button: {
      fontFamily: "Jost",
      fontSize: "16px",
      textTransform: "none",
      fontWeight: 600,
      boxShadow: "none",
      [breakpoints.up("lg")]: {
        fontSize: "20px",
        boxShadow: "none",
      },
    },
    display1: {
      fontSize: "48px",
      lineHeight: "56px",
      letterSpacing: "0.32px",
      fontFamily: "Cormorant Garamond",
      fontWeight: 800,
      [breakpoints.up("lg")]: {
        fontSize: "61px",
        lineHeight: "72px",
      },
    },
    display2: {
      fontSize: "34.5px",
      lineHeight: "40px",
      letterSpacing: "0.32px",
      fontFamily: "Cormorant Garamond",
      fontWeight: 800,
      [breakpoints.up("lg")]: {
        fontSize: "48px",
        lineHeight: "56px",
      },
    },
    overline: {
      fontSize: "14px",
      letterSpacing: "0.88px",
      lineHeight: "20px",
      fontWeight: 400,
    },
  } as Partial<Theme["typography"]>,
} as Partial<Theme>;
